import { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Constants from "../../../../Constants.json";
import AuthContext from "../../store/auth-context";
import InvelpsAuth from "./InvelpsAuth";

function accessTokenExpiration(accessToken) {
  try {
    const payload = JSON.parse(
      atob(accessToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
    );
    if (payload.exp) return new Date(payload.exp * 1000).toISOString();
  } catch (_) {
    /* ignore decode errors */
  }
  return new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString();
}

export default function LoginForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const authCtx = useContext(AuthContext);
  const returnTo = location.state?.returnTo || "/capital";

  const loginSubmit = async ({ email, password }) => {
    const res = await fetch(`${Constants.BACKEND_SERVER_BASE_URL}/token/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: email, password }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const detail = data.detail;
      const msg =
        typeof detail === "string"
          ? detail
          : Array.isArray(detail)
            ? detail[0]
            : "Identifiants incorrects.";
      throw new Error(msg);
    }

    authCtx.login(
      data.access,
      data.refresh,
      data.role || "User",
      accessTokenExpiration(data.access)
    );
  };

  return (
    <InvelpsAuth
      initialPage="login"
      loginSubmit={loginSubmit}
      onSuccess={() => navigate(returnTo, { replace: true })}
      onGoSignup={() => navigate("/signup", { state: { returnTo } })}
      onForgotPassword={() => navigate("/forgotpassword")}
    />
  );
}
